import React from 'react'
import './QuestAccountModal.css'

const QuestAccountModal = ({ isOpen, onClose, onCreateAccount }) => {
  if (!isOpen) return null

  return (
    <div className="quest-modal-overlay" onClick={onClose}>
      <div className="quest-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="quest-modal-header">
          <h2>Tournament Registration Required</h2>
          <button className="quest-modal-close" onClick={onClose}>×</button>
        </div>

        <div className="quest-modal-body">
          <p>You need to create an account to register for tournaments.</p>
          <p>Create your permanent RiftChess account to:</p>
          <ul>
            <li>Register for tournaments</li>
            <li>Track your rating progress</li>
            <li>Save your game history</li>
            <li>Compete in leaderboards</li>
          </ul>
        </div>

        <div className="quest-modal-footer">
          <button className="quest-modal-cancel" onClick={onClose}>
            Continue as Guest
          </button>
          <button className="quest-modal-create" onClick={onCreateAccount}>
            Create Account
          </button>
        </div>
      </div>
    </div>
  )
}

export default QuestAccountModal